import {
  Container,
  Section,
  MetricCard,
  DashboardChart,
  ActionGroup,
  Grid,
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Stack,
  Text,
} from '@tonic/shared/components/ui';
import { PageTitle } from "@/components/ui/PageTitle";
import {
  Package,
  TrendingUp,
  ShoppingBag,
  AlertTriangle,
  Plus,
  FileText,
  ArrowDownToLine,
  Settings,
  Boxes,
  RefreshCcw,
} from 'lucide-react';
import { useProducts } from '../../hooks/useProducts';
import { useState } from 'react';

export function ProductDashboard() {
  const [filters] = useState({});
  const { data: products, isLoading } = useProducts(filters);

  // Mock data for charts - in real app this would come from API/hooks
  const categoryData = [
    { name: 'Electronics', value: 45 },
    { name: 'Furniture', value: 30 },
    { name: 'Clothing', value: 15 },
    { name: 'Other', value: 10 },
  ];

  const statusData = [
    { name: 'Active', value: 65 },
    { name: 'Draft', value: 15 },
    { name: 'Discontinued', value: 10 },
    { name: 'Hidden', value: 10 },
  ];

  const quickActions = [
    {
      label: 'New Product',
      icon: Plus,
      onClick: () => console.log('New product clicked'),
    },
    {
      label: 'Generate Report',
      icon: FileText,
      onClick: () => console.log('Generate report clicked'),
    },
    {
      label: 'Export Catalog',
      icon: ArrowDownToLine,
      onClick: () => console.log('Export clicked'),
    },
    {
      label: 'Settings',
      icon: Settings,
      onClick: () => console.log('Settings clicked'),
    },
  ];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  return (
    <Container>
      <Section>
        <Stack space={6}>
          <PageTitle
            title="Products Dashboard"
            description="Overview of your product catalog, including standard and re-commerce items."
            actions={<ActionGroup actions={quickActions} />}
          />

          <Grid cols={1} mdCols={2} lgCols={4} gap={6}>
            <MetricCard
              title="Total Products"
              value={products?.length || '0'}
              description="Active products"
              icon={Boxes}
              trend={8}
            />
            <MetricCard
              title="Re-commerce Items"
              value="124"
              description="Products in re-commerce"
              icon={RefreshCcw}
              trend={15}
            />
            <MetricCard
              title="Total Sales"
              value="$45,678"
              description="Last 30 days"
              icon={ShoppingBag}
              trend={12}
            />
            <MetricCard
              title="Low Stock"
              value="23"
              description="Products below threshold"
              icon={AlertTriangle}
              trend={-5}
              trendColor="red"
            />
          </Grid>

          <Grid cols={1} mdCols={2} gap={6}>
            <Card>
              <CardHeader>
                <CardTitle>Product Distribution by Category</CardTitle>
              </CardHeader>
              <CardContent>
                <DashboardChart
                  type="pie"
                  data={categoryData}
                  dataKey="value"
                  xAxisKey="name"
                  colors={['#6366F1', '#10B981', '#F59E0B', '#3B82F6']}
                />
              </CardContent>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle>Products by Status</CardTitle>
              </CardHeader>
              <CardContent>
                <DashboardChart
                  type="pie"
                  data={statusData}
                  dataKey="value"
                  xAxisKey="name"
                  colors={['#10B981', '#F59E0B', '#EF4444', '#6366F1']}
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid cols={1} gap={6}>
            <Card>
              <CardHeader>
                <CardTitle>Recent Activity</CardTitle>
              </CardHeader>
              <CardContent>
                <Text color="muted">No recent activity to display</Text>
              </CardContent>
            </Card>
          </Grid>
        </Stack>
      </Section>
    </Container>
  );
}
